<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
            <!-- {{title}} -->
            <img :src="titleImage" />
            </div>
        </div>
        <div class="m-panel-body">
            <Echart ref="option" :options="option" style="height: 100%"></Echart>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import { listSize } from '@/utils/util'
import { getAction } from '@/api/manage'
const colorList = ["#9E87FF", '#73DDFF', '#fe9a8b', '#F56948', '#9E87FF']
const xData = ['北京', '上海', '广州', '深圳', '香港', '澳门', '台湾']
export default {
    props: {
            titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            option: {},
            intervalId:null,
            url: {
                getMeterVoltageByMeterId:"/jeecg-charge/meter/meterUpDataAnalysis/getMeterVoltageByMeterId"
            },
            getMeterVoltageByMeterId:[],
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.setOption();
            this.querygetMeterVoltageByMeterId();
        })
    },
    methods: {
        querygetMeterVoltageByMeterId() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        // params.areaId = this.queryParam.areaId
        // params.meterId = '00000623802653'
        // params.beginDate = '2020-12-15'
        // params.endDate = '2021-01-15'
        console.log(this.queryParam);
        console.log(params);
        getAction(this.url.getMeterVoltageByMeterId, params).then((res) => {
          if(res.success){
            this.getMeterVoltageByMeterId = res.result;
            console.log(this.getMeterVoltageByMeterId);
          }
        }) 
      },
        setOption() {
            this.option = {
                backgroundColor: '#fff',
                title: {
                    text: this.$t('电池电压折线统计图'),
                    textStyle: {
                        fontSize: 12,
                        fontWeight: 400
                    },
                    left: 'center',
                    top: '5%'
                },
                legend: {
                    icon: 'circle',
                    top: '5%',
                    right: '5%',
                    itemWidth: 6,
                    itemGap: 20,
                    textStyle: {
                        color: '#556677'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        label: {
                            show: true,
                            backgroundColor: '#fff',
                            color: '#556677',
                            borderColor: 'rgba(0,0,0,0)',
                            shadowColor: 'rgba(0,0,0,0)',
                            shadowOffsetY: 0
                        },
                        lineStyle: {
                            width: 0
                        }
                    },
                    backgroundColor: '#fff',
                    textStyle: {
                        color: '#5c6c7c'
                    },
                    padding: [10, 10],
                    extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)'
                },
                grid: {
                    top: '15%'
                },
                xAxis: [{
                    type: 'category',
                    data: xData,
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(107,107,107,0.37)', //x轴颜色
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            color: '#999' //坐标轴字颜色
                        },
                        margin: 15
                    },
                    axisPointer: {
                        label: {
                            padding: [11, 5, 7],
                            backgroundColor: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: '#fff' // 0% 处的颜色
                                }, {
                                    offset: 0.9,
                                    color: '#fff' // 0% 处的颜色
                                }, {
                                    offset: 0.9,
                                    color: '#33c0cd' // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: '#33c0cd' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        }
                    },
                    boundaryGap: false
                }],
                yAxis: [{
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(107,107,107,0.37)', //y轴颜色
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999'
                        }
                    },
                    splitLine: {
                        show: false
                    }
                }],
                series: [{
                    name: 'Adidas',
                    type: 'line',
                    data: [10, 10, 30, 12, 15, 3, 7],
                    symbolSize: 1,
                    symbol: 'circle',
                    smooth: true,
                    yAxisIndex: 0,
                    showSymbol: false,
                    lineStyle: {
                        width: 2,
                        color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                offset: 0,
                                color: '#9effff'
                            },
                            {
                                offset: 1,
                                color: '#9E87FF'
                            }
                        ]),
                        shadowColor: 'rgba(158,135,255, 0.3)',
                        shadowBlur: 10,
                        shadowOffsetY: 20
                    },
                    itemStyle: {
                        normal: {
                            color: colorList[0],
                            borderColor: colorList[0]
                        }
                    }
                }, 
                // {
                //     name: 'Nike',
                //     type: 'line',
                //     data: [5, 12, 11, 14, 25, 16, 10],
                //     symbolSize: 1,
                //     symbol: 'circle',
                //     smooth: true,
                //     yAxisIndex: 0,
                //     showSymbol: false,
                //     lineStyle: {
                //         width: 5,
                //         color: new echarts.graphic.LinearGradient(1, 1, 0, 0, [{
                //                 offset: 0,
                //                 color: '#73DD39'
                //             },
                //             {
                //                 offset: 1,
                //                 color: '#73DDFF'
                //             }
                //         ]),
                //         shadowColor: 'rgba(115,221,255, 0.3)',
                //         shadowBlur: 10,
                //         shadowOffsetY: 20
                //     },
                //     itemStyle: {
                //         normal: {
                //             color: colorList[1],
                //             borderColor: colorList[1]
                //         }
                //     }
                // }
                ]
            };
            let i = 0
            let that = this
            // setTimeout(()=> {
                this.intervalId = setInterval(function(){
                    console.log(i)
                    i = i === xData.length ? 0 : i+1
                    that.$refs.option.dispatchAction({
                        type: 'showTip',
                        seriesIndex:0,  // 显示第几个series
                        dataIndex: i // 显示第几个数据
                    });
                }, 1000)
            // },1000)
            // let chart = document.getElementById('chart-panel');
            // let myChart = echarts.init(chart)
            
        },
        clearIntervalId() {
            if(this.intervalId !== null){
                clearInterval(this.intervalId)
                this.intervalId = null;
            }
        },
        shut(){    //关闭按钮
        this.date = [];
        this.clearIntervalId();
        this.querygetMeterVoltageByMeterId();
        console.log(this.intervalId);
        console.log(this.intervalId !== null);
        }
    }
}
</script>
<style scoped>
.m-panel-body{
    height: 500px;
}
</style>